import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { PageHeader } from "@/components/DashboardShell";
import { StatusPill } from "@/components/brand";
import api from "@/lib/api";

function daysUntil(dateStr) {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr) - new Date()) / 86400000);
}

export default function AdminDrivers() {
  const [drivers, setDrivers] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/drivers");
    setDrivers(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (d) => {
    const next = d.status === "suspended" ? "active" : "suspended";
    try { await api.patch(`/users/${d.id}/status`, null, { params: { status: next } }); toast.success(`Driver ${next}`); load(); }
    catch { toast.error("Action failed"); }
  };

  return (
    <div>
      <PageHeader index="02" eyebrow="Driver Roster" title="Approved drivers" />
      <div className="border border-gray-200 divide-y divide-gray-200" data-testid="driver-roster">
        {drivers.length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No approved drivers yet.</div>}
        {drivers.map((d) => {
          const exp = d.compliance?.licence?.expiry;
          const days = daysUntil(exp);
          const warn = days !== null && days <= 30;
          return (
            <div key={d.id} className="flex items-center justify-between px-5 py-4 gap-4" data-testid={`driver-row-${d.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold text-[#0a0a0a]">{d.name}</span>
                  <StatusPill status={d.status} />
                  {warn && <span className="inline-flex items-center gap-1 text-xs text-orange-600"><AlertTriangle className="h-3 w-3" /> Licence {days < 0 ? "expired" : `${days}d`}</span>}
                </div>
                <div className="text-xs text-gray-500 mt-0.5 font-mono">
                  {d.region || "—"} · {d.compliance?.licence?.class} {d.compliance?.licence?.number} · {d.email}
                </div>
              </div>
              <button onClick={() => toggle(d)} data-testid={`toggle-driver-${d.id}`}
                className={`font-mono text-[11px] tracking-[0.1em] uppercase px-3 py-1.5 border transition-colors ${d.status === "suspended" ? "bg-[#0a0a0a] text-white border-[#0a0a0a]" : "border-orange-500 text-orange-600 hover:bg-orange-50"}`}>
                {d.status === "suspended" ? "Reactivate" : "Suspend"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
